import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { withRouter } from '../../WithRouter';

import HeaderText from './HeaderText';
import HeaderLinks from './HeaderLinks';

import { CUSTOM_THEME } from '../../../constants/themeConstants';

import askAuntyLogo from '../../../assets/images/ask_aunty_logo.png';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const pathname = window.location.pathname;
    const showOnBoardingText = pathname === '/onboarding' || pathname === '/account';
    const showLearningText = pathname.includes('/learning');
    const activeProfile = pathname === '/edit' ? null : 'active';

    let headerContent = null;
    if (showOnBoardingText) headerContent = <HeaderText text="Welcome to Ask Aunty!" />;
    else if (showLearningText)
      headerContent = (
        <HeaderText
          learningTitle={true}
          text={[
            <strong key={1} className="me-1">
              Micro-learning:
            </strong>,
            'Test your knowledge of workplace wellbeing',
          ]}
        />
      );
    else headerContent = <HeaderLinks activeProfile={activeProfile} pathname={pathname} />;

    return (
      <header className="header">
        <div
          className="container-fluid d-flex h-100 align-items-center"
          style={{ paddingLeft: 15, paddingRight: 15 }}
        >
          <div
            className="logo-holder"
          >
            <NavLink to="/" className="text-center w-100">
              <img
                width="100"
                height="90"
                className="logo-img"
                src={askAuntyLogo}
                onError={(e) => {
                  if (e.target.src !== askAuntyLogo) {
                    e.target.src = askAuntyLogo;
                  }
                }}
                alt="logo"
              />
            </NavLink>
          </div>
          {headerContent}
        </div>
      </header>
    );
  }
}

export default withRouter(Header);
